import React, { useEffect } from "react";
import img1 from "../assets/Contactless1.jpg";
import img2 from "../assets/web_bottle_filler.png";
import Footer from "../components/Footer";

const ContactlessWaterDispenser = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <div className="container py-5" style={{ marginTop: "50px" }}>
                <h1>Contactless / Touchless Water Dispensing System</h1>

                <p className="lead">
                    <strong>Smart. Hygienic. Touch-Free. Retrofit Ready.</strong>
                </p>

                <h4>Problem Statement</h4>
                <p>
                    In today’s world—especially post-COVID—hygiene and safety are more important than ever.
                    Traditional water dispensers still require physical touch, increasing the chances of
                    contamination and causing unnecessary water wastage in both public and private spaces.
                </p>

                <p>
                    What began as a pandemic-driven necessity has now become a long-term standard:
                    people expect touch-free, safe, and hygienic water access everywhere.
                </p>

                <h4>VionsTech Solution</h4>
                <p>
                    <strong>VionsTech</strong> introduces the <strong>Smart Contactless Water Dispensing System</strong>
                    (also known as a Touchless Water Dispensing System), an advanced automation module designed
                    to enable touch-free water dispensing in existing water systems such as coolers, fountains,
                    and bottle fillers.
                </p>

                <p>
                    The system operates using a high-precision IR sensor that detects the presence of a hand or
                    bottle and automatically controls the water flow only when required, ensuring hygienic
                    operation and reduced water wastage.
                </p>

                <div className="row my-4 gx-4 gy-4">
                    <div className="col-md-6 mb-3">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img1}
                                alt="Contactless Water Dispenser Controller 1"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "340px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img2}
                                alt="Contactless Water Dispenser Controller 3"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "340px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>
                <style>{`
                        .img-card {
                            background: #f8fafc;
                            border: 1px solid #e3e8ee;
                            border-radius: 16px;
                            padding: 24px;
                            box-shadow: 0 4px 24px rgba(25, 118, 210, 0.07);
                            transition: box-shadow 0.2s, transform 0.2s;
                            min-height: 260px;
                        }
                        .img-card:hover {
                            box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                            transform: translateY(-4px) scale(1.02);
                        }
                `}</style>

                <div className="my-4">
                    <div className="ratio ratio-16x9" style={{ maxWidth: "800px", margin: "0 auto" }}>
                        <iframe
                            src="https://www.youtube.com/embed/-ywXGlJ4L6E"
                            title="Contactless Water Dispenser Demo"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ContactlessWaterDispenser;